import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './ModernCards.scss';

const ModernCards = ({ title, subtitle, data }) => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100
    });
  }, []);

  return (
    <section className="modern-cards-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header" data-aos="fade-up">
          {title && <h2 className="section-title">{title}</h2>}
          {subtitle && <p className="section-subtitle">{subtitle}</p>}
          <div className="title-underline">
            <span className="underline-dot"></span>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="cards-grid">
          {data && data.map((item, index) => (
            <div
              key={item.id || index}
              className={`modern-card ${item.disabled ? 'disabled' : ''}`}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              onClick={() => {
                if (!item.disabled) {
                  if (item.href) {
                    window.location.href = item.href;
                  } else if (item.onClick) {
                    item.onClick();
                  }
                }
              }}
            >
              {/* Card Glow Effect */}
              <div className="card-glow"></div>

              {/* Card Content */}
              <div className="card-icon-wrapper">
                <div className="icon-bg">
                  {item.icon && (
                    <img src={process.env.PUBLIC_URL + item.icon} alt={item.title} />
                  )}
                </div>
                <div className="icon-circle"></div>
              </div>

              <div className="card-content">
                <h3 
                  className="card-title"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></h3>
                <p className="card-description">{item.para}</p>
              </div>

              {/* Card Footer with Arrow */}
              <div className="card-footer">
                <span className="card-link">
                  {item.disabled ? 'Próximamente' : 'Explorar'}
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </div>

              {/* Floating particles */}
              <div className="card-particles">
                <span className="particle"></span>
                <span className="particle"></span>
                <span className="particle"></span>
              </div>

              {/* Status badge for disabled */}
              {item.disabled && (
                <div className="status-badge">Próximamente</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModernCards;
